<template>
    <div>
        <section class="section-hero section-shaped my-0">
            <div class="shape shape-style-1 shape-blue">
                <span class="span-150"></span>
                <span class="span-50"></span>
                <span class="span-50"></span>
                <span class="span-75"></span>
                <span class="span-100"></span>
                <span class="span-75"></span>
                <span class="span-50"></span>
                <span class="span-100"></span>
                <span class="span-50"></span>
                <span class="span-100"></span>
            </div>
            <div class="container shape-container d-flex align-items-center">
                <div class="col px-0">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-lg-12 col-md-9 col-sm-12 col-12 text-center pt-lg">
                            <img src="img/brand/pandas/corona2.png" style="width: 400px;" class="mt-5 img-fluid floating">
                            <!--<div class="row mt-lg-5 justify-content-center align-items-center">-->
                                <!--<div class="col-12 col-lg-8">-->
                                    <!--<iframe height="375rem" src="https://www.youtube.com/embed/JceK0Wv9rfA" class="video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--</div>-->
                            <!--</div>-->


                            <h2 class="mt-3 text-white text-uppercase">{{alertMessage.m1}}</h2>

                            <p class="lead text-white mt-0 mb-0">{{alertMessage.m2}}</p>
                            <div class="mt-4">
                                <!--<base-button tag="a"-->
                                             <!--href="/covid"-->
                                             <!--class="mb-3 ml-3"-->
                                             <!--icon="ni ni-check-bold"-->
                                             <!--type="success">-->
                                    <!--latest COVID-19 update-->
                                <!--</base-button>-->
                                <!--<base-button tag="a"-->
                                             <!--href="#pandorum"-->
                                             <!--class="mb-3"-->
                                             <!--type="default"-->
                                             <!--icon="ni ni-world">-->
                                    <!--Check Out Pandorum-->
                                <!--</base-button>-->
                                <base-button tag="a"
                                             href="#subscribe"
                                             class="mb-3 ml-3"
                                             icon="ni ni-email-83"
                                             type="success">
                                    Subscribe
                                </base-button>
                                <base-button tag="a"
                                             href="#games"
                                             class="mb-3"
                                             type="white"
                                             icon="ni ni-controller">
                                    Explore Our experiences
                                </base-button>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5 row align-items-center justify-content-around stars-and-coded">
                    </div>

                </div>
            </div>
        </section>

        <section id="games" class="section-games section-lg section-sm section-md section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-0 shape-green shape-skew ">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="row mt-4">

            </div>
            <div class="container ">
                <div class="row align-items-center text-white d-flex justify-content-around">
                    <img src="img/brand/otc-logo-white.png" style="width: 150px;" class="img-fluid">


                </div>
                <!--<div class="row  align-items-center text-white d-flex justify-content-around">-->
                    <!--<h4 class="mt-2 display-3 text-white">Explore our experiences!</h4>-->

                <!--</div>-->
            </div>
        </section>

        <section class="section section-lg section-sm section-md mt--150">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-6 col-sm-8 col-11">
                        <div class="row row-grid justify-content-center">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <div class="row justify-content-center">
                                        <img style="height: 225px" src="img/brand/asheville/apartment/Apartment1.jpg" class="mb-4">
                                    </div>
                                    <h6 class="text-success text-uppercase"><router-link to="/apartment">Chapter 1: Occam's Apartment</router-link></h6>
                                    <p class="description mt-3">
                                      Your friend Detective William Occam recently died. Following his death, you received a mysterious letter that reinforces your belief that something was odd about his death. You decide to investigate on your own what really happened to William.
                                    </p>
                                    <div>
                                        <badge type="success" rounded>2-6 players</badge>
                                        <badge type="success" rounded>105 minutes</badge>
                                    </div>
                                    <base-button tag="a" v-on:click="tracker('Booking', 'Redirected to booking', 'Apartment on landing page')" href="https://offthecouch.io/book/otc" type="success" class="mt-4">
                                        Book now
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <div class="row justify-content-center">
                                        <img style="height: 225px" src="img/brand/asheville/gallery/ArtGallery1.jpg" class="mb-4">
                                    </div>
                                    <h6 class="text-warning text-uppercase"><router-link to="/gallery">Chapter 2: Norcross Art Gallery</router-link></h6>
                                    <p class="description mt-3">
                                      You followed leads that were left behind at Occam's Apartment and determined that the Norcross Art Gallery is where "he" likely is operating out of. <br>
                                    </p>
                                  <p style="margin-top: 65px;"></p>

                                  <div>
                                        <badge type="warning" rounded>2-6 players</badge>
                                        <badge type="warning" rounded>90 minutes</badge>
                                    </div>
                                    <base-button tag="a" v-on:click="tracker('Booking', 'Redirected to booking', 'Art Gallery on landing page')" href="https://offthecouch.io/book/otc" type="warning" class="mt-4">
                                        Book now
                                    </base-button>

                                </card>
                            </div>
                          <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                              <div class="row justify-content-center">
                                <img style="height: 225px" src="img/brand/asheville/morgue/m2.jpg" class="mb-4">
                              </div>
                              <h6 class="text-warning text-uppercase"><router-link to="/morgue">Chapter 3: The Morgue</router-link></h6>
                              <p class="description mt-3">
                                The man you have been hunting continues to evade you and this time he sends you to the Morgue where he wants to play a little game.  Will you be able to come out alive or join the rest of the bodies at this abandoned Morgue?
                              </p>
                              <p style="margin-top: 40px;"></p>

                              <div>
                                <badge type="default" rounded>2-6 players</badge>
                                <badge type="default" rounded>120 minutes</badge>
                              </div>
                              <base-button tag="a" v-on:click="tracker('Booking', 'Redirected to booking', 'Art Gallery on landing page')" href="https://offthecouch.io/book/otc" type="default" class="mt-4">
                                Book now
                              </base-button>

                            </card>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="pandorum" class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-black shadow border-0">
                            <img v-lazy="'img/brand/asheville/Asheville.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-black"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-black"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Asheville</h4>
                                <p class="lead text-italic text-white">
                                  Enter the world where families live peacefully, everyone knows each other, and the people actually like their elected officials.
                                  On the surface it is a utopia, but in the shadows is a dark secret that only you can bring to light.
                                  Can you survive the investigation?
                                </p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <!--<icon name="ni ni-world" class="mb-4" size="lg" type="primary" shadow rounded></icon>-->

                            <h3>A multi-hour experience set across several chapters</h3>
                            <!--<p class="lead">This game is nothing you've ever experience before</p>-->
                            <p class="mt-3">{{asheville.p1}}</p>
                            <p>{{asheville.p2}}</p>
<!--                            <base-button tag="a"-->
<!--                                         href="/pandorum"-->
<!--                                         class="mb-3 mb-sm-0"-->
<!--                                         type="white">-->
<!--                                Learn more-->
<!--                            </base-button>-->
                            <base-button tag="a"
                                         v-on:click="tracker('Booking', 'Redirected to booking', 'Pandorum on landing page')"
                                         href="https://offthecouch.io/book/otc"
                                         class="mb-3 mb-sm-0"
                                         type="danger">
                                Book now
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--<section class="section section-shaped my-0 overflow-hidden">-->
            <!--<div class="shape shape-style-3 bg-gradient-default shape-skew">-->
                <!--<span></span>-->
                <!--<span></span>-->
                <!--<span></span>-->
                <!--<span></span>-->
            <!--</div>-->
            <!--<div class="container pb-150">-->
                <!--<div class="row text-center justify-content-center">-->
                    <!--<div class="col-lg-12">-->
                        <!--<h2 class="display-3 text-white">What is an Escape Room?</h2>-->
                        <!--<p class="lead text-white">{{faq.what}}</p>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="row row-grid mt-5">-->
                    <!--<div class="col-lg-3 text-center">-->
                        <!--<icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>-->
                        <!--<h5 class="text-white mt-3" v-b-popover.hover.bottom="faq.reasons.r1.description"><strong>{{faq.reasons.r1.title}}</strong></h5>-->
                        <!--&lt;!&ndash;<p class="text-white mt-3">{{faq.reasons.r1.description}}</p>&ndash;&gt;-->
                    <!--</div>-->
                    <!--<div class="col-lg-3 text-center">-->
                        <!--<icon name="ni ni-satisfied" size="lg" gradient="white" shadow round color="primary"></icon>-->
                        <!--<h5 class="text-white mt-3" v-b-popover.hover.bottom="faq.reasons.r2.description"><strong>{{faq.reasons.r2.title}}</strong></h5>-->
                        <!--&lt;!&ndash;<p class="text-white mt-3">{{faq.reasons.r2.description}}</p>&ndash;&gt;-->
                    <!--</div>-->
                    <!--<div class="col-lg-3 text-center">-->
                        <!--<icon name="ni ni-favourite-28" size="lg" gradient="white" shadow round color="primary"></icon>-->
                        <!--<h5 class="text-white mt-3" v-b-popover.hover.bottom="faq.reasons.r3.description"><strong>{{faq.reasons.r3.title}}</strong></h5>-->
                        <!--&lt;!&ndash;<p class="text-white mt-3">{{faq.reasons.r3.description}}</p>&ndash;&gt;-->
                    <!--</div>-->
                    <!--<div class="col-lg-3 text-center">-->
                        <!--<icon name="ni ni-building" size="lg" gradient="white" shadow round color="primary"></icon>-->
                        <!--<h5 class="text-white mt-3" v-b-popover.hover.bottom="faq.reasons.r4.description"><strong>{{faq.reasons.r4.title}}</strong></h5>-->
                        <!--&lt;!&ndash;<p class="text-white mt-3">{{faq.reasons.r4.description}}</p>&ndash;&gt;-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</section>-->

        <section id="subscribe" class="section section-lg pt-0">
            <div class="container mt-5">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-9">
                                <h3 class="text-white">Subscribe to Off The Couch Updates and News</h3>
                                <p class="lead text-white mt-3">Sign up to receive the latest news about our experiences, promotions, contests, and quests!</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-12">
                                    <mailchimp-subscribe
                                            url="https://offthecouchgames.us19.list-manage.com/subscribe/post-json"
                                            user-id="82728a98795ba024a18046ea0"
                                            list-id="ae3ddd0c61"
                                    >

                                        <template v-slot="{ subscribe, setEmail, error, success, loading }">
                                            <form @submit.prevent="subscribe">
                                                <div class="row">
                                                    <div class="col-12 col-sm-9 col-lg-9">
                                                        <input class="form-control"
                                                               type="email"
                                                               v-model="user_email"
                                                               @input="setEmail($event.target.value)"/>

                                                        <div class="text-white" v-if="error">Sorry, this email could not be added</div>
                                                        <div class="text-white" v-if="success">Thanks for subscribing!</div>
                                                        <div class="text-white" v-if="loading">Loading…</div>
                                                    </div>
                                                    <div class="col-12 col-sm-3 col-lg-3">
                                                        <button v-on:click="subs()" class="btn btn-white text-primary mt-3 mt-lg-0 mt-md-0 mt-sm-0" type="submit">Submit</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </template>
                                    </mailchimp-subscribe>
                                <small v-show="invalidEmail" class="text-white">Please enter a valid email!</small>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section id="contact" class="section section-lg">
            <div class="container mt--100">
                <div class="row justify-content-center">
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-square-pin" class="mb-4" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3 class="mb-4">Contact Info</h3>

                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.4428230386716!2d-121.97536058459971!3d37.56818903179091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fc06128beea47%3A0x78cdcc517c6ce050!2s555%20Mowry%20Ave%2C%20Fremont%2C%20CA%2094536!5e0!3m2!1sen!2sus!4v1647627316219!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 mt-3 order-md-2">
                        <div class="text-center">
                            <img src="img/brand/pandas/conspiracy.png" style="width: 300px;" class="mt-3 img-fluid">
                        </div>
                        <ul class="list-unstyled mt-2">
                            <li class="py-3">
                                <div class="row">
                                    <div class="col-md-1 col-sm-1 col-1">
                                        <badge type="success" circle class="mr-3" icon="ni ni-pin-3"></badge>
                                    </div>
                                    <div class="ml-3 col-md-10 col-sm-9 col-9">
                                        <h6 class="mb-0">{{contactInfo.address1}}</h6>
                                        <h6 class="mb-0">{{contactInfo.address2}}</h6>
                                    </div>
                                </div>
                            </li>
                            <li class="py-3">
                                <div class="row">
                                    <div class="col-md-1 col-sm-1 col-1">
                                        <badge type="success" circle class="mr-3" icon="ni ni-mobile-button"></badge>
                                    </div>
                                    <div class="ml-3 col-md-10 col-sm-9 col-9">
                                        <h6 class="mb-0">{{contactInfo.phone}}</h6>
                                    </div>
                                </div>
                            </li>
                            <li class="py-3">
                                <div class="row">
                                    <div class="col-md-1 col-sm-1 col-1">
                                        <badge type="success" circle class="mr-3" icon="ni ni-email-83"></badge>
                                    </div>
                                    <div class="ml-3 col-md-10 col-sm-9 col-9">
                                        <h6 class="mb-0"><a v-on:click="tracker('Contact', 'Emailed contact', 'Link from Contact Info section on landing page')"
                                                href="mailto:contact@offthecouchgames.com">{{contactInfo.email}}</a></h6>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <modal :show.sync="modals.modal1">
            <h6 slot="header" class="modal-title" id="covid-modal">COVID-19 Update</h6>

            <p>{{modals.text1}}</p>
            <p>{{modals.text2}}</p>
            <p>{{modals.text3}}</p>
            <p><strong>{{modals.text4}} {{modals.text5}}</strong></p>
            <p>{{modals.text6}}</p>
            <p>Email: <a v-on:click="tracker('Contact', 'Emailed contact', 'Link from covid update modal on landing page')" href="mailto:contact@offthecouchgames.com">contact@offthecouchgames.com</a></p>
            <p>Phone: 408-478-2341</p>
            <p>{{modals.text7}}</p>
            <p>{{modals.text8}}</p>



<!--            <template slot="footer">-->
<!--                <base-button tag="a"-->
<!--                             href="https://offthecouchgamescom.resova.us/gift-voucher"-->
<!--                             type="primary">-->
<!--                    Buy Giftcard-->
<!--                </base-button>-->
<!--                <base-button type="link" class="ml-auto" @click="modals.modal1 = false">Close-->
<!--                </base-button>-->
<!--            </template>-->
        </modal>


        <modal :show.sync="modals.modal2">
            <div class="text-center">
                <img src="img/brand/pandas/squirrel.png" style="width: 150px;" class="img-fluid">

                <h6 class="mt-3">Thank you for signing up!</h6>
            </div>
            <div class="row">
                <div class="col-md-9">

                </div>
                <div class="col-md-3">
                    <base-button type="link" class="ml-auto" @click="modals.modal2 = false">Close
                    </base-button>
                </div>
            </div>
        </modal>

        <modal modal-classes="modal-dialog-centered modal-lg" :show.sync="modals.modal3">
            <div>
                <base-alert type="success">
                    <div class="row">
                        <div class="col-1">
                            <i class="fa fa-info-circle fa-3x"></i>
                        </div>
                        <div class="col-11 col-lg-11">
                            <h5 class="text-white">Demolition Delayed!  Off The Couch Remaining Open Until April 11th, 2021. Learn more <a href="https://www.offthecouchgames.com/demolition-delayed">here</a>.</h5>
                        </div>
                    </div>
                </base-alert>
                <h5 class="text-center">{{post.text2}}</h5>
                <p>{{post.text3}}</p>
                <div class="row justify-content-center">
                    <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                        <img v-lazy="'img/brand/blog/otc-reopening/hepa-filter.png'" class="img-fluid rounded"
                             style="height: 100px;">
                    </div>
                    <div class="col-lg-6">
                        <h6>{{post.measures.m6.title}}</h6>
                        <p>{{post.measures.m6.description}}</p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                        <img v-lazy="'img/brand/blog/otc-reopening/distance.png'" class="img-fluid rounded"
                             style="height: 100px;">
                    </div>
                    <div class="col-lg-6">
                        <h6>{{post.measures.m1.title}}</h6>
                        <p>{{post.measures.m1.description}}</p>
                    </div>
                </div>
                <div class="row mt-3 justify-content-center">
                    <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                        <img v-lazy="'img/brand/blog/otc-reopening/consent.png'" class="img-fluid rounded"
                             style="height: 100px;">
                    </div>
                    <div class="col-lg-6">
                        <h6>{{post.measures.m2.title}}</h6>
                        <p>{{post.measures.m2.description}}
                            <a href="https://offthecouch.io/checkin/otc"
                               v-on:click="tracker('Waiver', 'Redirected to waiver', 'Link from covid info page')">
                              https://offthecouch.io/checkin/otc</a>
                        </p>
                    </div>
                </div>
                <div class="row mt-3 justify-content-center">
                    <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                        <img v-lazy="'img/brand/blog/otc-reopening/hand-wash.png'" class="img-fluid rounded"
                             style="height: 100px;">
                    </div>
                    <div class="col-lg-6">
                        <h6>{{post.measures.m3.title}}</h6>
                        <p>{{post.measures.m3.description}}</p>
                    </div>
                </div>
                <div class="row mt-3 justify-content-center">
                    <div class="col-lg-2 col-sm-12 col-md-12 text-center">
                        <img v-lazy="'img/brand/blog/otc-reopening/spray.png'" class="img-fluid rounded"
                             style="height: 100px;">
                    </div>
                    <div class="col-lg-6">
                        <h6>{{post.measures.m4.title}}</h6>
                        <p>{{post.measures.m4.description}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9">

                </div>
                <div class="col-md-3">
                    <base-button type="link" class="ml-auto" @click="modals.modal3 = false">Close
                    </base-button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>

    import Modal from "../components/Modal";
    import { VBPopover } from "bootstrap-vue/esm/directives/popover/popover";
    import MailchimpSubscribe from 'vue-mailchimp-subscribe'
    const axios = require('axios')
    const url = "https://api.console.offthecouch.io/companies/1/subscribers"
    import VueGtm from 'vue-gtm';

    export default {
        name: "home",
        components: {Modal, MailchimpSubscribe},
        directives: {
            BPopover: VBPopover,
        },
        data () {
            return {
                user_email: '',
                post: {
                    text1: "Off The Couch is happy to announce that we have re-opened for business! Come and join us in an adventure in a private and safe environment.",
                    text2: "COVID-19 Safety Measures",
                    text3: "Our top priority is to keep both our employees and our customers safe. As part of that, we are strictly adhering to the following safety measures:",
                    measures: {
                        m1: {
                            title: "Private Experiences and Reduced Capacity",
                            description: "We are also capping the number of experiences available to 2 per time window.  This ensures that multiple groups remain completely separated. "
                        },
                        m2: {
                            title: "Online Waivers",
                            description: "Waivers are available via the website or directly at"
                        },
                        m3: {
                            title: "Hand Washing, Sanitizer, and Gloves!",
                            description: "All players are strongly encouraged to wash their hands before and after each experience. Hand sanitizer and gloves will also be offered to all players."
                        },
                        m4: {
                            title: "More Cleaning!",
                            description: "Employees will have an additional 30 minutes between experiences to reset and thoroughly clean all handled items and surfaces with medical-grade disinfectants."
                        },
                        m6: {
                            title: "Medical Grade H13 True HEPA Air Purifier",
                            description: "To ensure the safest experience we have recently installed Medical Grade H13 True HEPA Air purification into our experiences."
                        },
                    }
                },
                modals: {
                    modal1: false,
                    text1: "Hi Everyone!",
                    text2: "With the ongoing concerns about the COVID-19 outbreak, Off The Couch’s top priority is the safety of our customers and our employees.  To continue the battle against COVID-19,  the Public Health Office and Santa Clara County leadership has extended the Shelter in Place order until the end of May.  Due to this, we will be remaining closed until the shelter is lifted.",
                    text3: "You may book any of our experiences after May 31.  Our cancellation policy is flexible and we allow for rescheduling or full credit refunds if anything comes up.  Our available slots will also be restricted a bit to ensure proper social distancing even after the shelter is lifted.  We want to ensure that people are able to remain a safe distance from another and there is no contact between individuals outside of their respective groups.",
                    text4: "Alternatively, if you’d like to continue to support us, please consider purchasing a gift card from our website.",
                    text5: "We are currently offering a 20% bonus to all gift card values.  Gift certificates never expire and can be used at anytime for a future booking for yourself or others. Any help is greatly appreciated during this time and we look forward to seeing you soon.",
                    text6: "If you need to reach us, email or call.",
                    text7: "Thank you for understanding and support.  We look forward to seeing everyone soon!",
                    text8: "The OTC Team",
                    modal2: false,
                    modal3: false
                },
                email: null,
                invalidEmail: false,
                asheville: {
                  p1: "Asheville brings to life a unique experience where you as the player become the main characters in your own live action game. We removed the time limits to allow you the more realistic experience of investigating the world of Asheville at your own pace.",
                  p2:  "As a player you have the ability to save your progress throughout the game, allowing you to approach the experience the way you want.  Do you want to spend 4 hours and try and solve the mystery all at once or do you want to take your time and save after every hour?  The choice is yours, welcome to Asheville."
                },
                contactInfo: {
                    address1: "555 Mowry Avenue",
                    address2: "Fremont, CA 94536",
                    phone: "+1 (408) 478-2341",
                    email: "contact@offthecouchgames.com"
                },
                faq: {
                   what: "An escape room is a live adventure experience where you assemble a team of trusted companions to experience an immersive new world. There you will find hidden clues that will help you solve the various puzzles throughout the environment. These puzzles will take you down the path of solving the game's mysteries and emerging victorious before time runs out!",
                   reasons: {
                       r1: {
                           title: "Team Building",
                           description: "These live adventures are designed to be a group activities. Successfully completing an adventure will require teams to clearly communicate, openly share ideas, and cooperate with each other."
                       },
                       r2: {
                           title: "Family Fun",
                           description: "Experience a live adventure and enjoy working together as a family. Our fun activities are for both parents and kids. In fact, solving some of our puzzles may come more naturally to kids than adults!",
                       },
                       r3: {
                           title: "Date Night",
                           description: "Running out of fun things to do as a couple? What's more romantic than an adventure with your sweetheart? Spend the evening unraveling a mystery and make the next date an unforgettable one.",
                       },
                       r4: {
                           title: "Corporate Events",
                           description: "Give your employees an experience they'll never forget. Treat them to the best team building activity.  Watch them connect over a live adventure, where they have to work together to overcome difficult puzzles to share in the glory of coming out as champions!"
                       }

                   }
                },
                alertMessage:
                    {
                        m1: "New Location in Fremont Open Now",
                        m2: "Sign up for our news letter below for updates!",
                    }
            }
        },
        methods: {
            subs(){
                var data = {
                    email : this.user_email,
                    first_name : "",
                    last_name : ""
                }
                axios.post(url, data)
                    .then(response => {
                        //GA event
                        this.tracker('Subscribe', 'Subscribed', 'Subscription from landing page')
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            },
          async initializeGtm(gtmId) {
            console.log(gtmId)
            this.$gtm = this.$gtm || await this.initGtmPlugin(gtmId); // Prevent multiple initializations

            console.log(this.$gtm)
          },
          initGtmPlugin(gtmId) {
            // Manually initialize vue-gtm with fetched GTM ID
            VueGtm.install(this.$root.constructor, {
              id: gtmId,
              enabled: true,
              debug: process.env.NODE_ENV !== 'production',
              vueRouter: this.$router, // If you have router, pass it here
              loadScript: true,
            });
          },
        },
        mounted() {
          //this.initializeGtm('GTM-MVGW5C5')

          VueGtm.install(this.$root.constructor, {
            id: 'GTM-MVGW5C5',
            enabled: true,
            debug: process.env.NODE_ENV !== 'production',
            vueRouter: this.$router, // If you have router, pass it here
            loadScript: true,
          });

          console.log(this.$gtm)

        }
    };
</script>


<style scoped>
    .section-games {
        height: 380px;
        background-size: cover;
        background-position: center center;
    }
    .bg-black {
        background-color: black;
    }
    .video {
        width: 100%;
        object-fit: fill;
        position: relative;
    }

</style>

